var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchbar"},[_c('MyTextField',{attrs:{"label":_vm.label,"labelPosition":"top","placeholder":_vm.placeholder},on:{"onEnter":_vm.search},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}}),_c('v-icon',{staticClass:"search-icon",on:{"click":_vm.search}},[_vm._v("mdi-magnify")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }